// What the client portal shows a person once they are signed in.
//
// There is one entry point, /client-portal. What someone sees inside it comes
// from the sections they hold, not from which URL they were sent, so a client
// with one section never has to choose and a client with several always can.

export const SECTION_LABELS = {
  'ordering': 'Ordering',
  'timesheet-approvals': 'Timesheet approvals',
};

/**
 * Decide the landing view from the sections a contact holds.
 *
 * One section goes straight in, because a chooser with a single option is a
 * step that asks a question with one answer. Several offers the choice. None
 * is its own screen rather than an empty chooser or an error, because "your
 * sign-in works but nothing is switched on" is a real state with a real
 * explanation, and the person hitting it can do nothing about it themselves.
 */
export function landingView(features) {
  const keys = (features || []).map(f => (typeof f === 'string' ? f : f.key));
  if (keys.length === 0) return { view: 'none' };
  if (keys.length === 1) return { view: 'section', section: keys[0] };
  return { view: 'chooser' };
}

/** True when the person has somewhere else to switch to. */
export function canSwitchSection(features) {
  return (features || []).length > 1;
}

/** A section is only reachable if it is held. */
export function canOpenSection(features, key) {
  return (features || []).some(f => (typeof f === 'string' ? f : f.key) === key);
}
